import * as React from 'react';

const SvgMenu = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 328 262"
    style={{
      enableBackground: 'new 0 0 328 262'
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="M19.515 19.981h289c10.8 0 19.5 8.9 19.5 20s-8.7 20-19.5 20h-289c-10.8 0-19.5-8.9-19.5-20s8.7-20 19.5-20zM19.615 119.981h176.8c10.8 0 19.6 8.9 19.6 20s-8.7 20-19.6 20h-176.8c-10.8 0-19.6-8.9-19.6-20s8.7-20 19.6-20zM19.515 219.981h289c10.8 0 19.5 8.9 19.5 20s-8.7 20-19.5 20h-289c-10.8 0-19.5-8.9-19.5-20s8.7-20 19.5-20z" />
  </svg>
);

export default SvgMenu;
